import React from "react";
import "./Mouse.css";
const Mouse = () => {
  return (
    <div class="scrolldown-wrapper">
      <div class="scrolldown">
        <svg height="30" width="10">
          <circle class="scrolldown-p1" cx="5" cy="15" r="2" />
          <circle class="scrolldown-p2" cx="5" cy="15" r="2" />
        </svg>
      </div>
    </div>
  );
};

export default Mouse;
